import type { Bucket } from "../../types/experiment";
import { ExperimentType } from "../../types/experiment";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Trash2 } from "lucide-react";

interface BucketEditorProps {
  bucket: Bucket;
  index: number;
  onChange: (bucket: Bucket) => void;
  onRemove: () => void;
}

const experimentTypeOptions = Object.entries(ExperimentType)
  .filter(([k]) => isNaN(Number(k)))
  .map(([key, value]) => ({ value: value as number, label: key }));

function getEnumLabel(value: number): string {
  const option = experimentTypeOptions.find((o) => o.value === value);
  return option?.label ?? `Unknown (${value})`;
}

export function BucketEditor({ bucket, index, onChange, onRemove }: BucketEditorProps) {
  return (
    <div className="grid grid-cols-[24px_80px_80px_1fr_28px] gap-3 items-center py-1 px-1">
      <span className="text-[10px] text-overlay0 text-center">B{index + 1}</span>
      <Input
        type="number"
        value={bucket.start}
        onChange={(e) => onChange({ ...bucket, start: parseFloat(e.target.value) || 0 })}
        className="h-8 text-xs"
        placeholder="start"
      />
      <Input
        type="number"
        value={bucket.stop}
        onChange={(e) => onChange({ ...bucket, stop: parseFloat(e.target.value) || 0 })}
        className="h-8 text-xs"
        placeholder="stop"
      />
      <Select
        value={String(bucket.type)}
        onValueChange={(v) => onChange({ ...bucket, type: Number(v) })}
      >
        <SelectTrigger className="h-8 text-xs">
          <SelectValue>{getEnumLabel(bucket.type)}</SelectValue>
        </SelectTrigger>
        <SelectContent>
          {experimentTypeOptions.map((opt) => (
            <SelectItem key={opt.value} value={String(opt.value)}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button type="button" variant="ghost" size="icon" onClick={onRemove} className="h-7 w-7">
        <Trash2 className="h-3 w-3 text-overlay1 hover:text-red" />
      </Button>
    </div>
  );
}
